export const maintainColumns = [
  {
    title: '公司名称',
    dataIndex: 'companyName',
    key: 'companyName',
    ellipsis: true,
    scopedSlots: { customRender: 'companyName' }
  },
  {
    title: '公司地址',
    dataIndex: 'address',
    key: 'address',
    ellipsis: true
  },
  {
    title: '联系人',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '联系电话',
    dataIndex: 'userTel',
    key: 'userTel'
  },
  {
    title: '销售员',
    dataIndex: 'salesman',
    key: 'salesman'
  },
  {
    title: '服务员',
    dataIndex: 'serviceName',
    key: 'serviceName'
  },
  {
    title: '价格',
    dataIndex: 'price',
    key: 'price'
  },
  {
    title: '整机编号',
    dataIndex: 'machineId',
    key: 'machineId'
  },
  {
    title: '机型',
    dataIndex: 'machineType',
    key: 'machineType'
  },
  {
    title: '出厂时间',
    dataIndex: 'salesTime',
    key: 'salesTime'
  },
  {
    title: '保养时间',
    dataIndex: 'maintainSetTime',
    key: 'maintainSetTime'
  },
  {
    title: '每天运行时间',
    dataIndex: 'runtime',
    key: 'runtime'
  },
  {
    title: '上次保养日期',
    dataIndex: 'lastMaintainTime',
    key: 'lastMaintainTime'
  },
  {
    title: '剩余保养天数',
    dataIndex: 'leaveDays',
    key: 'leaveDays'
  },
  {
    title: '下次保养日期',
    dataIndex: 'maintainTime',
    key: 'maintainTime'
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark'
  }
]
